const actionTypeIdentifier = "7DDAC816-AABA-40C1-AB96-5BB5D2C91166";

export const setArticleHistoryLogsLoading = `SET-ARTICLE-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getArticleHistoryLogs = `GET-ARTICLE-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setArticleHistoryPageSize = `SET-ARTICLE-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetArticleHistory = `RESET-ARTICLE-HISTORY-${actionTypeIdentifier}`;
export const setArticleHistoryColSearchStr = `SET-ARTICLE-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
